import DownloadsConfiguratorSuccessModal, {
  DOWNLOADS_CONFIGURATOR_SUCCESS_MODAL,
} from './DownloadsConfiguratorSuccessModal';

export { DOWNLOADS_CONFIGURATOR_SUCCESS_MODAL };

export default DownloadsConfiguratorSuccessModal;
